import { useEffect, useState } from "react";
import styles from "./Test.module.css";
import Spark1 from "./Spark1";
import Spark1B from "./Spark1B";
import Spark2 from "./Spark2";
import PathAnimation from "./PathAnimation";

export default function Test() {
  const [showSparks1, setShowSparks1] = useState(false);
  const [showSparks2, setShowSparks2] = useState(false);
  const [showPathAnimation, setShowPathAnimation] = useState(false);
  return (
    <div className={styles.mainContainer}>
      <div className={styles.ItemContainer}>
        <div
          onClick={() => setShowSparks1(!showSparks1)}
          className={styles.Button}
        >
          CLICK ME
        </div>
        {showSparks1 && (
          <>
            <Spark1 />
            <Spark1B />
          </>
        )}
      </div>

      <div className={styles.ItemContainer}>
        <div
          onClick={() => setShowSparks2(!showSparks2)}
          className={styles.Button}
        >
          CLICK ME
        </div>
        {showSparks2 && <Spark2 />}
      </div>


    </div>
  );
}
